
import { AssetPreviewHeaderController } from './asset-preview-header.controller'

function assetPreviewHeader () {
  return {
    restrict: 'E',
    scope: {
      template: '<',
      location: '<',
      contextData: '<',
      onMoveAsset: '<',
      onDeleteAsset: '<',
      onRestoreAsset: '<',
      fromCampaignAction: '<',
      publicCampaign: '<',
      linkUuid: '<'
    },
    templateUrl: '/core/directives/asset-preview-header/asset-preview-header.html?$$REVISION$$',
    controller: AssetPreviewHeaderController
  }
}
export { assetPreviewHeader }
